import { createStore } from "vuex";

const store = createStore({
  state() {
    return {
      server: "https://jamback.stat.tj",
      // server:"https://localhost:44378",
      // server:"http://localhost:4493",

      version: 38,

      login: false,
      tername: "",
      count: 0,
      books: [],
      households: [],
      members: [],
      data: [],
      ter: [],
      class: [],
      atoken: "",
      rtoken: "",

      logins: [
        "admin",
        "hisor",
        "almosi",
        "jamhisor",
        "khonako",
        "dehqon",
        "durbat",
        "mirzotur",
        "mirzorizo",
        "hnavobod",
        "hsomon",
        "horien",
        "regar",
        "qaratog",
        "jura",
        "navob",
        "pakhta",
        "tursun",
        "rabot",
        "seshanbe",
        "10sol",
        "tursunzoda",
        "hasanova",
        "juzi",
        "shahrinav",
        "bogiston",
        "sabo",
        "istiqlol",
        "sharora",
        "dukoni",
        "pulisangin",
        "guliston",
        "vahdatlev",
        "vakhsh",
        "mashal",
        "20solistiq",
        "vrudaki",
        "tojikobod",
        "vahdat",
        "hulbuk",
        "mahmadaliev",
        "vguliston",
        "avazov",
        "vrudak",
        "vaysov",
        "rajabov",
        "tugarak",
        "dangara",
        "korez",
        "lolazor",
        "safobakh",
        "pushing",
        "sangtuda",
        "isharipov",
        "lohur",
        "sebiston",
        "20sol",
        "dehqonobod",
        "jilikul",
        "navzamin",
        "gulmurodov",
        "obikiik",
        "khayni",
        "fakhrobod",
        "qizilqala",
        "gallaobod",
        "hiloli",
        "niyoz",
        "zarkamar",
        "navobod",
        "khisrav",
        "sangin",
        "nazarov",
        "20istiqlol",
        "balkh",
        "orzu",
        "bkalinin",
        "madaniyat",
        "bnavobod",
        "halevard",
        "uzun",
        "frunze",
        "isomoni",
        "kyshbuston",
        "bokhtarien",
        "kushoriyon",
        "zargar",
        "sarvat",
        "mehnatob",
        "navbah",
        "ajomi",
        "giyosov",
        "ittifoq",
        "kalinin",
        "dusti",
        "iftokhor",
        "50sol",
        "yakkatut",
        "dahan",
        "zarbdor",
        "ziraki",
        "kulob",
        "jdusti",
        "vmilli",
        "qumsangir",
        "panj",
        "jistiqlol",
        "yakkadin",
        "muminobod",
        "balkhobi",
        "boggain",
        "dehibaland",
        "nnazarov",
        "childukhtaron",
        "shohin",
        "moskva",
        "dashtigulo",
        "panjrud",
        "qahramon",
        "mmehnatob",
        "turdiev",
        "chubek",
        "panjob",
        "farkhor",
        "vatan",
        "gayrat",
        "galaba",
        "gulshan",
        "dehqonarik",
        "zafar",
        "20solist",
        "jfarkhor",
        "darkad",
        "spanj",
        "shpanj",
        "sayfuddinov",
        "mehvar",
        "namuna",
        "ozodagon",
        "nurivahdat",
        "guliston",
        "vahdatlev",
        "sovet",
        "bobyunus",
        "rahimov",
        "kangurt",
        "karmshiev",
        "tanobchi",
        "karakamish",
        "gaffor",
        "khovaling",
        "sgugnov",
        "jombakht",
        "shahrtuz",
        "juranazarov",
        "obshor",
        "pakhtaobod99",
        "sadriddinov",
        "kholmat",
        "mahmudov",
        "dashtijum",
        "langardara",
        "sarichashma",
        "shurobod",
        "dogiston",
        "chagam",
        "yovon",
        "hayoti",
        "gulsara",
        "norin",
        "obsho",
        "huseynov",
        "sitora",
        "chorgul",
        "dahana",
        "dukoni",
        "pulisangin",
        "navruz",
        "nistiqlol",
        "firuza",
        "baljuvon",
        "amirshoev",
        "sarikhosor",
        "rahim",
        "tojikiiston",
        "kirov",
        "qubodiyon",
        "levakand",
        "takob",
        "vayni",
        "dehmalik",
        "ziddi",
        "luchob",
        "varzobqala",
        "vchorbog",
        "rsomonien",
        "rnavobod99",
        "rtursunzoda99",
        "chimteppa",
        "rguliston",
        "zaynabobod",
        "choryak",
        "esanboy",
        "qiblai",
        "chorgulteppa",
        "rossiya",
        "rlohur",
        "rohati",
        "sultonobod",
        "sarikishti",
        "chorteppa",
        "fayzobod",
        "fmehrob",
        "javonon",
        "qalaidasht",
        "miskinobod",
        "jfayzob99",
        "vashgird",
        "fbuston",
        "chashma",
        "roziq",
        "bahor",
        "gulist",
        "abdulo",
        "romit",
        "simiganj",
        "chorsu",
        "rajab",
        "chuyangaron",
        "ismoilov",
        "burunov",
        "garm",
        "rnavob",
        "jafr",
        "nusratullo",
        "qalanak",
        "qalaisur",
        "navdi",
        "rahimzoda",
        "tagoba",
        "hijborak",
        "obimehnat",
        "askalon",
        "yasman",
        "hoit",
        "qalaiob",
        "langari",
        "nushor",
        "shogadoev",
        "shirin",
        "sangvor",
        "tavildara",
        "vakhiyo",
        "childara",
        "svahdat",
        "darband",
        "komsomol",
        "mujiharf",
        "khumdon",
        "samsoliq",
        "hakimi",
        "yakhakust",
        "qadiob",
        "sicharog",
        "obigarm",
        "rogun1",
        "rogun2",
      ],
      showmenu: true,
      iduser: 0,
      terid: 0,
      book: "",
      household: {},
      member: {},

      mid: 0,
      spravka: {},
      danger: "Диққат",
      updatemessage:
        "Версияи барномаи Шумо куҳна аст. Лутфан тугмаи ОК-ро барои азнавкунии (обновления) барнома пахш намоед",
      memo1:
        "Дода шуд дар ин бора, ки шаҳрванд {0} соли таваллудаш {1} буда, дар деҳаи {2} дар хоҷагии №{3} ба қайд гирифта шуда ва дар ҳамин суроға зиндагонӣ менамояд.",
      memo2:
        "Дода шуд дар ин бора, ки шаҳрванд {0} соли таваллудаш {1} буда, дар деҳаи {2} дар хоҷагии №{3} ба қайд гирифта шуда ва дар ҳамин суроға зиндагонӣ менамояд. Дар суроғаи зерин инчунин шахсони зерин дар қайд мебошанд.",
    };
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    clearTokens(state) {
      state.atoken = null;
      state.rtoken = null;
      state.login = false;

      state.ter = "";

      state.tername = "";
      state.count = 0;
      state.books = [];
      state.households = [];
      state.members = [];
      state.data = [];
      state.ter = [];

      state.terid = 0;
      state.book = "";
      state.household = {};
      state.member = {};

      state.mid = 0;
      state.spravka = {};
    },
  },
  actions: {
    logout({ commit }) {
      commit("clearTokens");
    },
  },
});

export default store;
